/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PrivateHireQuickEstimatesForm_viewer = {
    readonly currentUser: {
        readonly fullName: string;
    } | null;
    readonly " $refType": "PrivateHireQuickEstimatesForm_viewer";
};
export type PrivateHireQuickEstimatesForm_viewer$data = PrivateHireQuickEstimatesForm_viewer;
export type PrivateHireQuickEstimatesForm_viewer$key = {
    readonly " $data"?: PrivateHireQuickEstimatesForm_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PrivateHireQuickEstimatesForm_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PrivateHireQuickEstimatesForm_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentUser",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "fullName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '6f4042dc75a51c42b57986c76b753d46';
export default node;
